import { render, staticRenderFns } from "./AdminRolePermissions.vue?vue&type=template&id=481e8a10&scoped=true&"
import script from "./AdminRolePermissions.vue?vue&type=script&lang=js&"
export * from "./AdminRolePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e8a10",
  null
  
)

export default component.exports